<script setup lang="ts">
import { useUserContextStore } from '../../stores/userContext.ts'
import { useRouter } from 'vue-router'
import { useQuery } from '@vue/apollo-composable'
import { GET_CLINICS } from '../../graphql/queries.ts'
import { computed } from 'vue'
import type { Clinic } from '@/stores/types.ts'


const router = useRouter()

const { result } = useQuery(GET_CLINICS)

const clinics = computed(() =>
  (result.value?.clinics ?? []).map((clinic: Clinic) => {
    return {
      title: clinic.name,
      subtitle: clinic.location,
      action: () => {
        router.push({
          name: 'home',
          params: { clinicId: clinic.id },
        })
      },
    }
  }))

</script>

<template>
  <v-card width="900px" class="mx-auto my-16 rounded-xl">
    <v-card-title class="text-dark">
      <h4 class="text-center">Clinic Selection</h4>
    </v-card-title>

    <v-container>
      <v-row no-gutters>
        <v-col cols="12" sm="5">
          <img
            :width="300"
            class="ma-8"
            cover
            src="/map-location-svgrepo-com.svg"
          />
        </v-col>

        <v-col cols="12" sm="1" class="d-flex justify-center">
          <v-divider vertical class="my-8" />
        </v-col>

        <v-col cols="12" sm="6" class="ma-auto">
          <v-list v-if="clinics" lines="two">
            <v-list-item
              class="hover-list-item rounded-xl"
              v-for="clinic in clinics"
              :key="clinic.title"
              :subtitle="clinic.subtitle"
              :title="clinic.title"
              @click="clinic.action"
              clickable
              hover
            >
              <template v-slot:prepend>
                <v-avatar class="bg-secondary">
                  <v-icon color="white">mdi-hospital-box</v-icon>
                </v-avatar>
              </template>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style scoped>
.card {
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 12px 0 rgba(0, 0, 0, 0.19);
}

.hover-list-item {
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.hover-list-item:hover {
  background-color: #e0f7fa; /* Light teal for hover effect */
}

.card-title {
  justify-content: center;
}
</style>
